import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VersionEditor.Vue?vue&type=script&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VersionEditor.Vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionEditor.Vue?vue&type=script&lang=js
// module id = 85
// module chunks = 0